

export function GetPassportEmailBody(applicantName, selectedDate, selectedStart, selectedEnd, applicantEmail, type, id) {
  var aptType = "Individual";
  if (type === 'F') 
  {
    // Add minutes
    let endDatetime = new Date(selectedDate + ' ' + selectedEnd);
    //endDatetime.setTime(endDatetime.getTime() + (30 * 60 * 1000));;
    selectedEnd = endDatetime.toLocaleTimeString();

    aptType = "Family";
  }

  return 'Dear ' + applicantName + ',' + ' <br/><br/>' +
    'If you are 15 minutes late for your appointment you might be asked to re-schedule.' + ' <br/><br/>' +
    'Appointment Date/Time <br/>' +
    '<hr />'+
    'Date: &nbsp;' + selectedDate + ' <br/>' +
    'Time: &nbsp;' + selectedStart + '-' + selectedEnd + ' <br/>' +
    'Type: &nbsp;' + aptType + ' <br/><br/>' +
    'Applicant Information' + ' <br/>' +
    '<hr />' +
    'Name: &nbsp;' + applicantName + ' <br/>' +
    'Email: &nbsp;' + applicantEmail + ' <br/><br/>' +
    'Important Notes' + ' <br/>' +
    '<hr />' + 
    'Option:  To cancel the appointment, <a href="https://scheduler.orem.gov/tabs/Cancel/' + id + '"' + '>please click here.</a>' + '<br/>' +
    'We want to prepare you for your upcoming passport appointment. Please bring the following items with you: <br/>' +
    '1. &nbsp;	Applications. Please prepare your application in advance by visiting https://travel.state.gov/content/travel/en/passports/how-apply/forms.html. The various applications are described here. Fill out the correct application for your situation and print the last two pages to bring with you to your appointment. ' + ' <br/>' +
    '2.	&nbsp; Identification: If the application is for a child who is under the age of 16, we will need both parents present with their IDs. If the application is for a person over the age of 16, please bring their state IDs or driver license. If the applicant is 16 or 17 years old and does not have a state ID or driver license, we will need a copy of one of the parent’s ID. If the identification for the applicant is not a Utah state issued ID or driver license, please bring at least two other documents that either have a picture or name of the applicant (i.e. Social security card, or medical insurance card or school ID can also be accepted). We may ask that you write a short explanation of why you do not have a Utah state ID.' + ' <br/>' +
    '3.	&nbsp; Birth certificate or previous passport (or both if under the age of 16): Birth certificates must be the original and not a photocopy. If the applicant is over the age of 16 and has a previous passport, we will just need the previous passport.' + ' <br/>' +
    '4. &nbsp; Passport photos: Photos must have been taken within 6 months of application submission. If you do not have passport photos, there are several businesses in Orem (i.e.: Allen’s Camera, FedEx, Walgreens) that provide that service. We offer passport photo services in our office for a fee of $20.00.' + ' <br/>' +
    '5.	&nbsp; Passport fees:  The passport fee must be paid with a personal check, money order or cashier`s check.The check should be payable to the US Department of State.The fee is $130 for those over 16 years of age and $100 for children under the age of 16. The applicant`s full name and date of birth should be printed on the check. We can print money orders for a $5 fee.' +
    'The execution fee is $35 per application. It can be paid by cash, card or check but it must be separate from the check paid to the US Department of State. ' +
    'We will ask that you reschedule your appointment if you are missing any one of the items above, as we cannot submit incomplete applications.  We are open: M, T, Th 7:30am - 4:00pm, W 8:30-4:00, F by appointment only.  ' + ' <br/><br/>' +
    'Location' + ' <br/>' +
    '<hr />' +
    '56 North State Street, Orem, UT 84057' + 
    ' <br/><br/>' +
    '<hr />' +
    'If you have any further questions, please contact us at (801) 229-7275.' + 
    'This is an auto-generated message. Please do not reply to this message' + ' <br/>';

}


export function GetFingerprintEmailBody(applicantName, selectedDate, selectedStart, selectedEnd, applicantEmail, id) {
  var aptLocation ="56 North State Street, Orem, UT 84057"
  var aptType = "311 Employment Fingerprint Appointment";

return 'Dear ' + applicantName + ',' + ' <br/><br/>' +
    'If you are 15 minutes late for your appointment you might be asked to re-schedule.' + ' <br/><br/>' +
    'Appointment Date/Time <br/>' +
    '<hr />' +
    'Date: &nbsp;' + selectedDate + ' <br/>' +
    'Time: &nbsp;' + selectedStart + '-' + selectedEnd + '<br/>' +
    'Type: &nbsp;' + aptType + '<br/><br/>' +
    'Applicant Information' + ' <br/>' +
    '<hr />' +
    'Name: &nbsp;' + applicantName + ' <br/>' +
    'Email: &nbsp;' + applicantEmail + ' <br/><br/>' +
    'Important Notes' + ' <br/>' +
    '<hr />' +
    'We want to prepare you for your upcoming fingerprint appointment: <br/>' +
    '1. &nbsp;	Please bring picture identification with you to your appointment. ' + ' <br/>' +
    '2. &nbsp; Only the person being fingerprinted will be allowed in the fingerprinting room. We do not fingerprint anyone under the age of 16.  Please do not bring minor children to your fingerprinting appointment. ' + ' <br/>' +
    '3. &nbsp; To cancel the appointment, <a href="https://scheduler.orem.gov/tabs/Cancel/' + id + '"' + '> please click here.</a> ' + ' </br>' +
    'If you have any further questions, please contact us at (801) 229-7275.' + ' <br/><br/>' +
    'Location' + ' <br/>' +
     '<hr />' +
     aptLocation + ' <br/><br/>' +
    '<hr />' +
    'This is an auto-generated message. Please do not reply to this message' + ' <br/>';

}

export function GetCourtFingerprintEmailBody(applicantName, selectedDate, selectedStart, selectedEnd, applicantEmail, birthday, id) {

  var aptLocation = "97 East Center Street, Orem, UT 84057"
  var  aptType = "Orem Justice Court Fingerprint Appointment";

  return 'Dear ' + applicantName + ',' + ' <br/><br/>' +
    'If you are 15 minutes late for your appointment you might be asked to re-schedule.' + ' <br/><br/>' +
    'Appointment Date/Time <br/>' +
    '<hr />' +
    'Date: &nbsp;' + selectedDate + ' <br/>' +
    'Time: &nbsp;' + selectedStart + '-' + selectedEnd + '<br/>' +
    'Type: &nbsp;' + aptType + '<br/><br/>' +
    'Applicant Information' + ' <br/>' +
    '<hr />' +
    'Name: &nbsp;' + applicantName + ' <br/>' +
    'Email: &nbsp;' + applicantEmail + ' <br/>' +
    'Date of Birth: &nbsp;' + birthday + ' <br/><br/>' +
    'Important Notes' + ' <br/>' +
    '<hr />' +
    'We want to prepare you for your upcoming fingerprint appointment: <br/>' +
    '1. &nbsp;	Please bring picture identification with you to your appointment. ' + ' <br/>' +
    '2. &nbsp; To cancel the appointment, <a href="https://scheduler.orem.gov/tabs/Cancel/' + id + '"' + '> please click here.</a> ' + ' </br>' +
    'If you have any further questions, please contact us at (801) 229-7275.' + ' <br/><br/>' +
    'Location' + ' <br/>' +
    '<hr />' +
    aptLocation + ' <br/><br/>' +
    '<hr />' +
    'This is an auto-generated message. Please do not reply to this message' + ' <br/>';

}



export function GetCancelEmailBody(applicantName, selectedDate, selectedStart, selectedEnd, applicantEmail, type) {
  var aptType = '';
  var aptLocation = '';
  if (type === 'F') {
    aptType = "311 Employment Fingerprint Appointment";
    aptLocation = "56 North State Street, Orem, UT 84057";
  }
  else if (type === 'C') {
    aptType = "Orem Justice Court Fingerprint Appointment";
    aptLocation = "97 East Center Street, Orem, UT 84057";
  }
  else {
    aptType = "311 Passport Appointment";
    aptLocation = "56 North State Street, Orem, UT 84057";
  }


  return 'Dear ' + applicantName + ',' + ' <br/><br/>' +
    'You have requested to cancel the following appointment:' + ' <br/><br/>' +
    'Appointment Date/Time <br/>' +
    '<hr />' +
    'Date: &nbsp;' + selectedDate + ' <br/>' +
    'Time: &nbsp;' + selectedStart + '-' + selectedEnd + ' <br/>' +
    'Type: &nbsp;' + aptType + ' <br/><br/>' +
    'Applicant Information' + ' <br/>' +
    '<hr />' +
    'Name: &nbsp;' + applicantName + ' <br/>' +
    'Email: &nbsp;' + applicantEmail + ' <br/><br/>' +
    'Important Notes' + ' <br/>' +
    '<hr />' +
    'If you have any further questions, please contact us at (801) 229-7275.' + ' <br/><br/>' +
    'Location' + ' <br/>' +
    '<hr />' +
    aptLocation + ' <br/><br/>' +
    '<hr />' +
    'This is an auto-generated message. Please do not reply to this message' + ' <br/>';

}
